import type { TExcursionFiltersState } from '@/entities/filter/store/excursion';

export const excursionMapFilterDataToSogu = (data: Partial<TExcursionFiltersState>) => {
  const startDate = data.date?.from ?? null;
  const endDate = data.date?.to ?? null;
  const startDuration = data.duration?.[0]?.toString() ?? null;
  const endDuration = data.duration?.[1]?.toString() ?? null;

  // Для разделения фильтров формата проведения туров было
  // внедрено дублирование функционала. В сторе заведено еще одно состояние tourFormat
  // которое дублирует состояние type у фильтров формата экскурсий
  // в апи и в урлах значение из tourFormat приравнивается к апи полю type
  const buildTypeForSogu = (): string[] | null => {
    const { type, tourFormat } = data;

    if (type && type.length) {
      return [...type];
    }

    if (tourFormat && tourFormat.length) {
      const set = new Set<string>([...tourFormat]);

      return Array.from(set);
    }

    return null;
  };

  return {
    persons_count: data.date?.persons || null,
    price_start: data.price?.[0] || null,
    price_end: data.price?.[1] || null,
    date_start: startDate || null,
    date_end: endDate || null,
    type: buildTypeForSogu(),
    movement_type: (data.movementTypes || []).join(',') || null,
    sorting: data.sorting || null,
    start_duration: startDuration,
    end_duration: endDuration,
    children_allowed: data.childrenAllowed || null,
    duration_interval: data.durationInterval || null,
    start_time_interval: data.startTimeInterval || null,
  };
};
